(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/nova/price-label.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/nova/price-label.js');
"use strict";

const _excluded = ["className", "variant", "size", "edge", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const cn = function () {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
};
const priceLabelEdgePaths = {
  xs: {
    width: 9,
    height: 24,
    d: 'M9.35123 0C7.6248 0 6.03361 0.934444 5.19261 2.44218L0.944789 10.0577C0.269217 11.2689 0.269216 12.7436 0.944789 13.9548L5.19261 21.5703C6.0336 23.078 7.6248 24.0125 9.35123 24.0125'
  },
  sm: {
    width: 14,
    height: 32,
    d: 'M14.5463 0C11.833 0 9.30368 1.37178 7.82377 3.64595L1.90861 12.7358C0.613866 14.7254 0.613866 17.2913 1.90861 19.2809L7.82377 28.3707C9.30368 30.6449 11.833 32.0167 14.5463 32.0167'
  },
  md: {
    width: 16,
    height: 40,
    d: 'M16.5 0C13.4946 0 10.7114 1.58268 9.17467 4.16548L1.57273 16.9425C0.447884 18.8331 0.447884 21.1877 1.57273 23.0783L9.11107 35.7484C10.6872 38.3975 13.5419 40.0208 16.6244 40.0208'
  },
  lg: {
    width: 20,
    height: 48,
    d: 'M20 0C16.1047 0 12.5025 2.06902 10.5399 5.43375L1.46625 20.9894C0.376568 22.8575 0.37657 25.1675 1.46625 27.0356L10.5399 42.5912C12.5013 45.9539 16.1071 48.0155 20 48'
  },
  xl: {
    width: 24,
    height: 58,
    d: 'M25.9683 0H23.3665C19.0408 0 15.0499 2.32808 12.9208 6.09348L1.63824 26.0467C0.602053 27.8792 0.602053 30.1208 1.63824 31.9533L12.9208 51.9065C15.0499 55.6719 19.0408 58 23.3665 58H25.9683'
  }
};
const priceLabelRootSizeClass = {
  xs: 'price-label--size-xs',
  sm: 'price-label--size-sm',
  md: 'price-label--size-md',
  lg: 'price-label--size-lg',
  xl: 'price-label--size-xl'
};
const priceLabelRootVariantClass = {
  primary: 'price-label--variant-primary',
  secondary: 'price-label--variant-secondary',
  'primary-inverted': 'price-label--variant-primary-inverted'
};
const priceLabelBodySizeClass = {
  xs: 'price-label__body--size-xs',
  sm: 'price-label__body--size-sm',
  md: 'price-label__body--size-md',
  lg: 'price-label__body--size-lg',
  xl: 'price-label__body--size-xl'
};
const priceLabelBodyVariantClass = {
  primary: 'price-label__body--variant-primary',
  secondary: 'price-label__body--variant-secondary',
  'primary-inverted': 'price-label__body--variant-primary-inverted'
};
const priceLabelBodyEdgeClass = {
  dual: 'price-label__body--edge-dual',
  leading: 'price-label__body--edge-leading',
  trailing: 'price-label__body--edge-trailing'
};
function priceLabelBodyVariants() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$edge = _ref.edge,
    edge = _ref$edge === void 0 ? 'dual' : _ref$edge;
  return cn('price-label__body', priceLabelBodySizeClass[size], priceLabelBodyVariantClass[variant], priceLabelBodyEdgeClass[edge]);
}
function priceLabelVariants() {
  let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant;
  return cn('price-label', priceLabelRootSizeClass[size], priceLabelRootVariantClass[variant]);
}
const PriceLabelEdge = _ref3 => {
  let size = _ref3.size,
    position = _ref3.position;
  const _priceLabelEdgePaths$ = priceLabelEdgePaths[size],
    width = _priceLabelEdgePaths$.width,
    height = _priceLabelEdgePaths$.height,
    d = _priceLabelEdgePaths$.d;
  return React.createElement("svg", {
    "aria-hidden": "true",
    className: cn('price-label__edge', position === 'trailing' && 'price-label__edge--trailing'),
    focusable: "false",
    height: height,
    overflow: "visible",
    viewBox: "0 0 ".concat(width, " ").concat(height),
    width: width
  }, React.createElement("path", {
    d: d,
    fill: "currentColor"
  }));
};

const PriceLabelCurrency = _ref4 => {
  let price = _ref4.price,
    _ref4$currency = _ref4.currency,
    currency = _ref4$currency === void 0 ? 'KR' : _ref4$currency;
  return React.createElement(React.Fragment, null, price, React.createElement("span", {
    className: "price-label__currency"
  }, currency));
};

const PriceLabel = _ref5 => {
  let className = _ref5.className,
    variant = _ref5.variant,
    size = _ref5.size,
    edge = _ref5.edge,
    children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded);
  const resolvedSize = size !== null && size !== void 0 ? size : 'md';
  const resolvedEdge = edge !== null && edge !== void 0 ? edge : 'dual';
  const hasLeadingEdge = resolvedEdge === 'dual' || resolvedEdge === 'leading';
  const hasTrailingEdge = resolvedEdge === 'dual' || resolvedEdge === 'trailing';
  return React.createElement("div", _extends({
    className: cn(priceLabelVariants({
      variant,
      size
    }), className)
  }, props), hasLeadingEdge && React.createElement(PriceLabelEdge, {
    position: "leading",
    size: resolvedSize
  }), React.createElement("span", {
    className: priceLabelBodyVariants({
      variant,
      size,
      edge: resolvedEdge
    })
  }, children), hasTrailingEdge && React.createElement(PriceLabelEdge, {
    position: "trailing",
    size: resolvedSize
  }));
};
setGlobal('svs.tickets.next.components.nova.PriceLabel', PriceLabel);
setGlobal('svs.tickets.next.components.nova.PriceLabelCurrency', PriceLabelCurrency); 

 })(window);